import { inject, injectable } from 'inversify';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';
import type { ClientGameRepositoryInterface } from '@client/entity/client-game/domain/repository/client-game.repository';
import type { ClientGame } from '@client/entity/client-game/domain/model/client-game.model';

@injectable()
export class ClientGameService {
  public constructor(
    @inject(ClientGameDependencyTypes.ClientGameRepository)
    private readonly repository: ClientGameRepositoryInterface,
  ) {}

  public getClientGames(clientId: string): Promise<ClientGame[]> {
    return this.repository.fetchClientGames(clientId);
  }
}
